export default __webpack_public_path__ + "static/media/33_photo.b16477fb.jpeg";